import React, { useEffect, useState } from "react";
import BannerDetail from './BannerDetails';
import HomeAboutDetail from './HomeAbout';
import ServiceList from './ServicesList';
import BannerBottom from './BannerBottom';
import AdditionalServicesSection from './AdditionalServicesSection';
import ReadyToPlan from './ReadyToPlan';
import TeamMembersEditor from './TeamMembersEditor';
import ClientsEditor from './ClientsEditor';
import WhyChooseUsBox from './WhyChooseUsBox';
import HomepageVideo from './HomepageVideo';





const HomePage=()=>{
  return (
    <div>
      <BannerDetail/>
      <HomeAboutDetail/>
      <ServiceList/>
      <BannerBottom/>
      <AdditionalServicesSection/>
      <ReadyToPlan/>
      <TeamMembersEditor/>
      <ClientsEditor/>
      <WhyChooseUsBox/>
      <HomepageVideo/>
    </div>
  );
}
export default HomePage;